import { sysUserLogin, sysUserPhoneLogin } from "@/api/sysUser";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";
import { userDetails } from "@/api/user";
import userTypeList from "@/../public/static/json/userTypeList.json";
import { encryption } from "@/utils/common";

const state = {
  userInfo: getToken() || {},
  userTypeList: userTypeList || [],
};

const mutations = {
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
};

const actions = {
  // user login
  login({ commit }, origuserInfo) {
    if (origuserInfo.type == "user") {
      let userInfo = encryption({
        data: origuserInfo.loginForm,
        encryption: "happy@earth@moon",
        param: ["password"],
      });
      const { mobile, ...params } = userInfo;
      return sysUserLogin({ mobile: mobile.trim(), ...params }).then((resp) => {
        const { bean } = resp;
        commit("SET_USER_INFO", bean);
        setToken(bean);
      });
    } else {
      let phoneData = origuserInfo.loginForm;
      return sysUserPhoneLogin({
        mobile: phoneData.phone.trim(),
        smsCode: phoneData.smsCode.trim(),
      }).then((resp) => {
        const { bean } = resp;
        commit("SET_USER_INFO", bean);
        setToken(bean);
      });
    }
  },

  // user logout
  logout({ commit, state, dispatch }) {
    commit("SET_USER_INFO", {});
    removeToken();
    resetRouter();
    dispatch("tagsView/delAllViews", null, { root: true });
  },

  refresh({ commit, state, dispatch }) {
    const { userInfo } = state;
    return userDetails({ userId: userInfo.userId }).then((resp) => {
      const {
        bean: { mobile, userName },
      } = resp;
      const info = { ...userInfo, mobile, userName };
      commit("SET_USER_INFO", info);
      setToken(info);
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + "-token";

    commit("SET_TOKEN", token);
    setToken(token);

    const { roles } = await dispatch("getInfo");

    resetRouter();

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch("permission/generateRoutes", roles, {
      root: true,
    });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch("tagsView/delAllViews", null, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
